<template>
  <div>
    <app-cells>
      <app-button @click.native="onCalculate" ref="calculate">Calculate</app-button>
      <app-button @click.native="onDelete" theme="error" ref="delete">Delete</app-button>
    </app-cells>
    <app-cells>
      <h2 class="title">Equipments</h2>
      <app-button @click.native="onShowModal(null, 'equip')" size="small">Create</app-button>
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': table_preloader }"
    >
      <template #h__name><div class="table-default__left">Item</div></template>
      <template #name="{ row }"><div class="table-default__left">{{ row.item.name }}</div></template>
      <template #planned="{ row }">{{ amountFormat(row.planned_count) }}</template>
      <template #real="{ row }">{{ amountFormat(row.real_count) }}</template>
      <template #given="{ row }">{{ amountFormat(row.given_count) }}</template>
      <template #return="{ row }">{{ amountFormat(row.return_count) }}</template>
      <template #returned="{ row }">{{ amountFormat(row.returned_count) }}</template>
      <template #write_off="{ row }">
          <span
            :style="{ 'backgroundColor': row.write_off ? '#e85c20' : '#77b017' }"
            class="status-tag"
          >
            {{ row.write_off ? 'Yes' : 'No' }}
          </span>
      </template>
      <template #weight="{ row }">{{ amountFormat(row.weight) }}</template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowModal(row, 'equip')" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
          </button>
          <button @click="onShowDeleteModal(row.id, 'equip')" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="onClickPagination($event, 'pagination', 'fetchItems')"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="40" />
    </app-cells>
    <app-cells>
      <h2 class="title">Crew</h2>
      <app-button @click.native="onShowModal(null, 'crew')" size="small">Create</app-button>
    </app-cells>
    <v-client-table
      :data="table_crew.items"
      :columns="table_crew.columns"
      :options="table_crew.options"
      class="table-default"
      :class="{ 'table-default--loading': table_preloader_crew }"
    >
      <template #h__name><div class="table-default__left">Position</div></template>
      <template #name="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
      <template #planned="{ row }">{{ amountFormat(row.planned_count) }}</template>
      <template #real="{ row }">{{ amountFormat(row.real_count) }}</template>
      <template #assigned="{ row }">{{ amountFormat(row.assigned_count) }}</template>
      <template #weight="{ row }">{{ amountFormat(row.weight) }}</template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowModal(row, 'crew')" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
          </button>
          <button @click="onShowDeleteModal(row.id, 'crew')" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="onClickPagination($event, 'pagination_crew', 'fetchItemsCrew')"
          v-if="pagination_crew.pages > 1"
          v-model="pagination_crew.page"
          :page-count="pagination_crew.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination_crew.count" :count="table_crew.items.length" :page="pagination_crew.page" :limit="40" />
    </app-cells>
    <modal
      name="equip_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideModal('equip_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ item_to_action ? 'Update' : 'Create' }} {{ modal_type === 'equip' ? 'equipment' : 'crew' }}</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group v-if="modal_type === 'equip'" label="Item" required>
              <template #additional>
                <app-checkbox
                  v-model="form.write_off"
                  label="Write off"
                />
              </template>
              <app-select
                v-model="form.item"
                :options="item_options"
                :reduce="item => item.id"
                placeholder="Item"
                :error="$v.form.item.$error"
              />
              <template #error>
                <div v-if="$v.form.item.$dirty && !$v.form.item.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-else label="Position">
              <app-select
                v-model="form.position"
                :options="position_options"
                :reduce="item => item.code"
                placeholder="Position"
                :error="$v.form.position.$error"
              />
              <template #error>
                <div v-if="$v.form.position.$dirty && !$v.form.position.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Planned">
              <app-input
                v-model.number="form.planned_count"
                placeholder="Planned"
                type="number"
              />
            </app-form-group>
            <app-form-group label="Real">
              <app-input
                v-model.number="form.real_count"
                placeholder="Real"
                type="number"
              />
            </app-form-group>
            <app-form-group v-if="modal_type === 'crew'" label="Assigned">
              <app-input
                v-model.number="form.assigned_count"
                placeholder="Assigned"
                type="number"
              />
            </app-form-group>
            <template v-else>
              <app-form-group label="Given">
                <app-input
                  v-model.number="form.given_count"
                  placeholder="Given"
                  type="number"
                />
              </app-form-group>
              <app-form-group label="Return">
                <app-input
                  v-model.number="form.return_count"
                  placeholder="Return"
                  type="number"
                />
              </app-form-group>
              <app-form-group label="Returned">
                <app-input
                  v-model.number="form.returned_count"
                  placeholder="Returned"
                  type="number"
                />
              </app-form-group>
            </template>
            <app-form-group label="Weight">
              <app-fin-number
                v-model="form.weight"
                placeholder="Weight"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit">{{ item_to_action ? 'Save' : 'Create' }}</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideModal('delete_modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete item
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onHideModal('delete_modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="deleteItem">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingGroupsEquipmentItems,
  postClimbingGroupsEquipmentItems,
  patchClimbingGroupsEquipmentItems,
  deleteClimbingGroupsEquipmentItems,
  patchClimbingGroupsCalculateEquipment,
  deleteClimbingGroupsCalculateEquipment,
  getClimbingGroupsCrewPositions,
  postClimbingGroupsCrewPositions,
  patchClimbingGroupsCrewPositions,
  deleteClimbingGroupsCrewPositions,
  getStorageItems,
  getClimbingMountainCrewPositions
} from '@/http'
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'ClimbingGroupsDetailCalculations',
  data() {
    return {
      table: {
        items: [],
        columns: [
          'name',
          'planned',
          'real',
          'given',
          'return',
          'returned',
          'write_off',
          'weight',
          'controls',
        ],
        options: {
          headings: {
            'name': 'Item',
            'planned': 'Planned',
            'real': 'Real',
            'given': 'Given',
            'return': 'Return',
            'returned': 'Returned',
            'write_off': 'Write off',
            'weight': 'Weight',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      table_crew: {
        items: [],
        columns: [
          'name',
          'planned',
          'real',
          'assigned',
          'weight',
          'controls',
        ],
        options: {
          headings: {
            'name': 'Position',
            'planned': 'Planned',
            'real': 'Real',
            'assigned': 'Assigned',
            'weight': 'Weight',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_crew: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_crew: false,
      form: {},
      item_to_action: null,
      modal_type: 'equip',
      item_options: [],
      position_options: [],
    }
  },
  validations: {
    form: {
      item: {
        required: requiredIf(function() {
          return this.modal_type === 'equip'
        })
      },
      position: {
        required: requiredIf(function() {
          return this.modal_type === 'crew'
        })
      },
    },
  },
  created() {
    Promise.all([
      getStorageItems(),
      getClimbingMountainCrewPositions(),
      this.fetchItems(),
      this.fetchItemsCrew()
    ]).then(response => {
      this.item_options = response[0].data
      this.position_options = response[1].data
    })
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getClimbingGroupsEquipmentItems(
        Number(this.$route.params.id),
        { page: this.pagination.page, page_size: 40 }
      )
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    async fetchItemsCrew() {
      this.table_preloader_crew = true
      const response = await getClimbingGroupsCrewPositions(
        Number(this.$route.params.id),
        { page: this.pagination_crew.page, page_size: 40 }
      )
      this.table_crew.items = response.data.results
      this.pagination_crew.pages = response.data.pages
      this.pagination_crew.count = response.data.count
      this.table_preloader_crew = false
    },
    onClickPagination(page, pagination, action) {
      this[pagination].page = page
      this[action]()
    },
    onShowModal(data, modal_type) {
      this.modal_type = modal_type
      this.item_to_action = data?.id
      if (!this.item_to_action) this.form = {}
      else {
        if (this.modal_type === 'equip') {
          this.form = {
            item: data.item.id,
            write_off: data.write_off,
            planned_count: data.planned_count,
            real_count: data.real_count,
            given_count: data.given_count,
            return_count: data.return_count,
            returned_count: data.returned_count,
            weight: data.weight,
          }
        } else {
          this.form = {
            position: data.position.code,
            real_count: data.real_count,
            planned_count: data.planned_count,
            assigned_count: data.assigned_count,
            weight: data.weight,
          }
        }
      }
      this.$v.form.$reset()
      this.$modal.show('equip_modal')
    },
    onHideModal(modal_name) {
      this.$modal.hide(modal_name)
    },
    onShowDeleteModal(item_id, modal_type) {
      this.item_to_action = item_id
      this.modal_type = modal_type
      this.$modal.show('delete_modal')
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (this.modal_type === 'equip') {
        if (!this.item_to_action) {
          postClimbingGroupsEquipmentItems(Number(this.$route.params.id), this.form)
            .then(() => {
              this.fetchItems()
              this.$notify({
                type: 'success',
                title: 'Item created',
              })
              this.onHideModal('equip_modal')
            })
            .catch(() => { this.$refs.submit.preload = false })
        } else {
          patchClimbingGroupsEquipmentItems(Number(this.$route.params.id), this.item_to_action, this.form)
            .then(() => {
              this.fetchItems()
              this.$notify({
                type: 'success',
                title: 'Data saved',
              })
              this.onHideModal('equip_modal')
            })
            .catch(() => { this.$refs.submit.preload = false })
        }
      } else {
        if (!this.item_to_action) {
          postClimbingGroupsCrewPositions(Number(this.$route.params.id), this.form)
            .then(() => {
              this.fetchItemsCrew()
              this.$notify({
                type: 'success',
                title: 'Crew created',
              })
              this.onHideModal('equip_modal')
            })
            .catch(() => { this.$refs.submit.preload = false })
        } else {
          patchClimbingGroupsCrewPositions(Number(this.$route.params.id), this.item_to_action, this.form)
            .then(() => {
              this.fetchItemsCrew()
              this.$notify({
                type: 'success',
                title: 'Data saved',
              })
              this.onHideModal('equip_modal')
            })
            .catch(() => { this.$refs.submit.preload = false })
        }
      }
    },
    onDeleteItem() {
      this.$refs.deleteItem.preload = true
      if (this.modal_type === 'equip') {
        deleteClimbingGroupsEquipmentItems(Number(this.$route.params.id), this.item_to_action)
          .then(() => {
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Item deleted',
            })
            this.onHideModal('delete_modal')
          })
          .catch(() => {
            this.$refs.deleteItem.preload = false
          })
      } else {
        deleteClimbingGroupsCrewPositions(Number(this.$route.params.id), this.item_to_action)
          .then(() => {
            this.fetchItemsCrew()
            this.$notify({
              type: 'success',
              title: 'Crew deleted',
            })
            this.onHideModal('delete_modal')
          })
          .catch(() => {
            this.$refs.deleteItem.preload = false
          })
      }
    },
    onCalculate() {
      this.$refs.calculate.preload = true
      patchClimbingGroupsCalculateEquipment(Number(this.$route.params.id))
        .then(() => {
          this.fetchItems()
          this.fetchItemsCrew()
          this.$refs.calculate.preload = false
        })
        .catch(() => { this.$refs.calculate.preload = false })
    },
    onDelete() {
      this.$refs.delete.preload = true
      deleteClimbingGroupsCalculateEquipment(Number(this.$route.params.id))
        .then(() => {
          this.fetchItems()
          this.fetchItemsCrew()
          this.$refs.delete.preload = false
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    amountFormat(amount) {
      return new Intl.NumberFormat('ru-RU').format(amount)
    },
  }
}
</script>
